import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
const CopyContext = createContext((english) => english);
export const IafCopyProvider = ({ translate, children }) => _jsx(CopyContext.Provider, { value: translate, children: children });
export const useIafCopy = () => useContext(CopyContext);
//# sourceMappingURL=copy.js.map